import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../../AbstractElements";
import { Blog, BlogDetailsTitle } from "../../../../Constants/Constants";
import BlogFilter from "../BlogGrids/BlogFilter/BlogFilter";
import BlogBody from "./BlogBody/BogBody";
import { Fragment } from "react/jsx-runtime";

const BlogDetailsContainer = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle={BlogDetailsTitle} parent={Blog} />
      <Container fluid className="blog-detail-page">
        <Row>
          <BlogBody />
          <BlogFilter />
        </Row>
      </Container>
    </Fragment>
  );
};

export default BlogDetailsContainer;
